import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as CookieConsent from 'vanilla-cookieconsent';

@Injectable({
  providedIn: 'root'
})
export class CookieConstent {

  private platformId = inject(PLATFORM_ID);

  initializeCookieConsent() {
    if (isPlatformBrowser(this.platformId)) {
      CookieConsent.run({
        cookie: {
          name: 'cc_cookie',
          useLocalStorage: true,
          expiresAfterDays: 365,
        },
        guiOptions: {
          consentModal: {
            layout: 'cloud inline',
            position: 'bottom center',
            equalWeightButtons: true,
          },
          preferencesModal: {
            layout: 'box',
            equalWeightButtons: true,
          },
        },
        categories: {
          necessary: {
            enabled: true,
            readOnly: true,
          },
        },
        language: {
          default: 'es',
          translations: {
            es: {
              consentModal: {
                title: 'Configuración de Cookies',
                description:
                  'Esta aplicación utiliza cookies únicamente para mostrar el mapa de Google. Si rechazas las cookies, el mapa no se mostrará correctamente.',
                acceptAllBtn: 'Aceptar',
                acceptNecessaryBtn: 'Rechazar',
              },
              preferencesModal: {
                title: 'Gestiona tus preferencias de cookies',
                savePreferencesBtn: 'Guardar preferencias',
                sections: [
                  {
                    title: 'Cookies Necesarias',
                    description:
                      'Las cookies necesarias permiten que los mapas de Google funcionen correctamente en esta aplicación. Sin estas cookies, no se podrán visualizar los mapas.',
                  },
                ],
              },
            },
          },
        }
      });

      window.addEventListener('click', (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (target && target.innerText === 'Aceptar') {
          this.saveConsentDecision('accepted');
        } else if (target && target.innerText === 'Rechazar') {
          this.saveConsentDecision('rejected');
        }
      });
    }
  }

  private saveConsentDecision(decision: 'accepted' | 'rejected') {
    localStorage.setItem('userConsentDecision', decision);
  }

  public getConsentStatus(): string | null {
    return localStorage.getItem('userConsentDecision');
  }

  public showConsentModal() {
    if (isPlatformBrowser(this.platformId)) {
      CookieConsent.show(true);
    }
  }
}
